module.exports = __webpack_public_path__ + "static/img/weather23.703d9436.png";